/**
 * 七牛图片 loader（独立 util，供 MMImage 内部使用；P1 全局接入后也会被
 * common.next.config.js 的 images.loader: 'custom' + loaderFile 引用）。
 *
 * 抽自 packages/h5/components/MMImage/index.tsx 的内联 qiniuLoader。
 * 行为等价：
 *   - isAni=true → 原样返回 src（动图不走 imageView2 参数）
 *   - 默认 quality=75
 *   - formatWebp=true → 追加 /format/webp
 *
 * Next.js 风格 loader（符合 ImageLoader 签名）后续单独导出（见文件尾）。
 */

export interface QiniuLoaderOpts {
  src: string;
  width: number;
  quality?: number;
  /** 动图（gif 等）：跳过 Qiniu imageView2 处理，避免首帧化 */
  isAni?: boolean;
  /** 输出 webp 格式（七牛支持场景） */
  formatWebp?: boolean;
}

export function qiniuLoader({ src, width, quality, isAni, formatWebp }: QiniuLoaderOpts): string {
  if (isAni) return src;
  let url = `${src}?imageView2/2/w/${width}/q/${quality ?? 75}`;
  if (formatWebp) {
    url += '/format/webp';
  }
  return url;
}

export default qiniuLoader;

// ---------------------------------------------------------------------------
// Next.js 全局 custom loader 入口（P1 接入时由 common.next.config.js 引用）
// 签名：({ src, width, quality }) => string
// 静态决策 isAni / formatWebp：从 src 扩展名判断 gif；默认开 webp。
// ---------------------------------------------------------------------------

export function nextImageLoader({
  src,
  width,
  quality,
}: {
  src: string;
  width: number;
  quality?: number;
}): string {
  const isAni = /\.gif(\?|$)/i.test(src);
  return qiniuLoader({ src, width, quality, isAni, formatWebp: true });
}
